import { render, staticRenderFns } from "./SidebarImage.vue?vue&type=template&id=1650ddd2&"
import script from "./SidebarImage.vue?vue&type=script&lang=js&"
export * from "./SidebarImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports